import { AppBar, Divider, Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import * as QueryString from 'query-string';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import axios from '../../axios-pod';
import { IUser } from '../../models/states';
import banner from '../../static/icons/banner.svg';
// import amagiLogo from "../../static/icons/amagiLogo.svg";
import news from '../../static/icons/news.svg';
import web from '../../static/icons/web.svg';
import {
  basicLogin,
  forgotPassword,
  login,
  logout,
  setPassword
} from '../../store/actions/userActions';
import withErrorHandler from '../../utilities/withErrorHandler';
import history from './../../utilities/history';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginForm from './LoginForm';
import SetPasswordForm from './SetPasswordForm';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: '100vh',
      background: `radial-gradient(center center,circle cover,#007cae,#004d81,#0b1d3f)`
    },
    box: {
      top: '20%',
      left: '65%',
      width: '28%',
      maxWidth: '450px',
      background: 'rgba(0,0,0,0.3)',
      position: 'relative'
    },
    textField: {
      margin: '10px 0',
      backgroundColor: '#fff',
      borderRadius: '2% 2%',
      padding: '5px'
    },
    margin: {
      margin: '1.5vh 0'
    },
    dot: {
      height: '10px',
      width: '10px',
      margin: '0 10px',
      backgroundColor: 'yellow',
      borderRadius: '50%',
      display: 'inline-block'
    },
    appbar: {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      position: 'absolute',
      top: '0',
      left: '0',
      color: '#fff',
      boxShadow: 'unset !important'
    },
    title: {
      position: 'absolute',
      top: '20%',
      left: '5%',
      color: '#fff'
    },
    divider: {
      backgroundColor: 'rgba(255,255,255,0.5)',
      margin: '5px 0',
      width: '100%'
    },
    subheading: {
      fontWeight: 300,
      padding: '0 50px',
      alignItems: 'center'
    },
    form: {
      padding: '30px',
      paddingTop: '15px',
      display: 'flex',
      flexDirection: 'column'
    },
    navigationWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginTop: '20px'
    },
    navigationItem: {
      display: 'flex',
      flexDirection: 'row',
      color: '#fff'
    },
    typography: {
      color: '#fff',
      padding: '10px '
    },
    link: {
      cursor: 'pointer'
    },
    hide: {
      display: 'none'
    },
    input: {
      fontSize: 14
      // fontStyle: "italic",
    },
    signInBtn: {
      whiteSpace: 'nowrap'
    },
    loginBtnWrapper: {
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%',
      position: 'absolute'
    }
  });

interface ILoginOwnProps extends WithStyles<typeof styles> {}

interface ILoginStateProps {
  isAuthenticated: boolean;
  user: IUser;
  session: string;
  challenge: string;
}
interface ILoginState {
  showPassword: boolean;
  showForgotPasswordForm: boolean;
  confirmationCode: string | string[];
}

interface ILoginDispatchProps {
  login: (payload: any) => void;
  logout: () => any;
  forgotPassword: (payload: any) => any;
  setPassword: (payload: any) => any;
  basicLogin: (payload: any) => void;
}

type ILoginProps = ILoginOwnProps & ILoginStateProps & ILoginDispatchProps;

class Login extends React.Component<ILoginProps, ILoginState> {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      showForgotPasswordForm: false,
      confirmationCode: ''
    };
  }
  handleLogin = (response: any) => {
    const payload = {
      token: response.tokenId
    };
    this.props.login(payload);
  };
  ILoginDispatchProps;

  handleTogglePassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  handleBasicLogin = values => {
    if (values.new_password && values.new_password.length !== 0) {
      values.challenge = this.props.challenge;
      values.session = this.props.session;
    }
    this.props.basicLogin(values);
  };

  renderHeader = (): React.ReactNode => {
    const { classes } = this.props;
    return (
      <AppBar position="static" className={classes.appbar}>
        <div className={classes.navigationWrapper}>
          <div className={classes.navigationItem} style={{ marginLeft: '5%' }}>
            {/* <img src={amagiLogo} alt=""/> */}
          </div>
          <div
            className={classes.navigationItem}
            style={{ marginRight: '7%', paddingBottom: '5px' }}
          >
            <div className={classes.navigationItem}>
              <img src={news} alt={''} />
              <a
                href="https://www.amagi.com/newsroom/"
                target="_blank"
                style={{ textDecoration: 'none' }}
              >
                <Typography className={classes.typography}>News</Typography>
              </a>
            </div>
            <div
              className={classes.navigationItem}
              style={{ marginLeft: '20px' }}
            >
              <img src={web} alt={''} />
              <a
                href="https://www.amagi.com"
                style={{ textDecoration: 'none' }}
                target="_blank"
              >
                <Typography className={classes.typography}>
                  www.amagi.com
                </Typography>
              </a>
            </div>
          </div>
        </div>
      </AppBar>
    );
  };

  renderDescription = () => {
    const { classes } = this.props;
    return (
      <div className={classes.title}>
        <Typography variant="h4" style={{ color: '#f7d002' }}>
          POD
          <span style={{ fontWeight: 300, color: '#fff' }}>
            {' '}
            CLOUDPORT MONITORING
          </span>
        </Typography>
        <Divider className={classes.divider} />
        <Typography variant="h6" color="inherit" className={classes.subheading}>
          Simple <span className={classes.dot} />
          Transparent <span className={classes.dot} />
          Automated
        </Typography>
      </div>
    );
  };

  handleSubmitForgotPassword = values => {
    this.props.forgotPassword({
      email: values.email
    });
  };

  handleSetPassword = values => {
    this.props.setPassword({
      email: values.email,
      confirmation_code: this.state.confirmationCode,
      password: values.newPassword
    });
  };

  renderLoginForm = () => {
    const { classes } = this.props;
    return (
      <Paper className={classes.box}>
        {this.state.showForgotPasswordForm ? (
          <ForgotPasswordForm
            onSubmit={this.handleSubmitForgotPassword}
            closeShowPassword={() =>
              this.setState({ showForgotPasswordForm: false })
            }
          />
        ) : this.state.confirmationCode ? (
          <SetPasswordForm
            closeSetPasswordForm={() => this.setState({ confirmationCode: '' })}
            onSubmit={this.handleSetPassword}
          />
        ) : (
          <LoginForm
            showPassword={this.state.showPassword}
            onSubmit={this.handleBasicLogin}
            onTogglePassword={this.handleTogglePassword}
            onGoogleSignIn={this.handleLogin}
            isChangePassword={Boolean(this.props.challenge)}
            title={'SIGN IN'}
            openShowPassword={() =>
              this.setState({ showForgotPasswordForm: true })
            }
            // location={this.props.location}
          />
        )}
      </Paper>
    );
  };

  public render() {
    const { classes } = this.props;
    let authRedirect = <React.Fragment />;
    const params = QueryString.parse(history.location.search);
    if (params.confirmationCode) {
      this.setState({ confirmationCode: params.confirmationCode });
      history.push('/login');
    }

    if (this.props.isAuthenticated && this.props.user.status) {
      authRedirect = <Redirect to="/" />;
    }

    // Set the confirmation code if available and then render the set password new password form
    return (
      <div className={classes.root}>
        <img
          src={banner}
          alt=""
          style={{ bottom: '0%', width: '53%', left: '5%', position: 'fixed' }}
        />
        {authRedirect}
        {this.renderHeader()}
        {this.renderDescription()}
        {this.renderLoginForm()}
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: ILoginOwnProps) => {
  return {
    isAuthenticated: state.user.token.length !== 0,
    user: state.user.userInfo,
    session: state.user.session,
    challenge: state.user.challenge
  };
};

const mapDispatchToProps: ILoginDispatchProps = {
  login,
  logout,
  basicLogin,
  forgotPassword,
  setPassword
};

export default withStyles(styles)(
  connect<ILoginStateProps, ILoginDispatchProps, ILoginOwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(Login, axios))
);
